import { defineStore } from 'pinia'

import { ref } from 'vue'

export const useWorfklowUI = defineStore('workflowUi', () => {
  const compareLedgerId = ref<string | null>(null)
  const compareMode = ref(false)
  const reloadingMode = ref(false)
  const reloadingLedger = ref(false)

  function setCompareLedgerId(ledgerId: string | null): void {
    compareLedgerId.value = ledgerId
  }

  function toggleReloadingLedger(): void {
    reloadingLedger.value = !reloadingLedger.value
  }

  function toggleReloadingMode(): void {
    reloadingMode.value = !reloadingMode.value
  }

  function updateCompareMode(value: boolean): void {
    compareMode.value = value
  }

  return {
    compareLedgerId,
    compareMode,
    reloadingLedger,
    reloadingMode,
    setCompareLedgerId,
    toggleReloadingLedger,
    toggleReloadingMode,
    updateCompareMode,
  }
})
